import { AutoSizer, MultiGrid } from 'react-virtualized';
import { useMultiGrid, useTableHeight } from '~/components/MultiGrid/helperHooks';
import * as MultiGridStyles from '~/components/MultiGrid/styles';
import { INVOICE_ALL_FIELDS, INVOICE_FIELDS_ORDER } from './constants';
import { useEffect } from 'react';
import { getMultiGridSettings } from '~/components/MultiGrid/helpers';
import { CELL_SETTINGS } from '~/components/MultiGrid/constants';
import GridCell from './GridCell';
import { useInvoiceListContext } from './hooks/useInvoiceListContext';

const InvoiceTable = () => {
  const { listIds, maxListItems } = useInvoiceListContext();

  const selectedFilters: Array<string> = [];
  const listLength = maxListItems ?? listIds.length;
  const fieldsOrderLength = INVOICE_FIELDS_ORDER.length;

  const { multiGridRef, onScroll } = useMultiGrid();
  const { tableHeight, listRef } = useTableHeight(listLength, selectedFilters.length, true);

  useEffect(() => {
    multiGridRef.current?.recomputeGridSize();
  }, [fieldsOrderLength, multiGridRef]);

  if (fieldsOrderLength === 0) {
    return null;
  }

  const multiGridSettings = getMultiGridSettings(INVOICE_ALL_FIELDS);


  return (
    <MultiGridStyles.ListWrapper
      key={listIds[0] ?? listIds.length}
      ref={listRef}
      className="full-flex"
    >
      <AutoSizer disableHeight>
        {({ width }) => {
          const totalFixedWidth = INVOICE_FIELDS_ORDER.slice(0, -1).reduce(
            (sum, field) => sum + INVOICE_ALL_FIELDS[field].width,
            0,
          );
          const lastColumnWidth = Math.max(
            width - totalFixedWidth,
            INVOICE_ALL_FIELDS[INVOICE_FIELDS_ORDER[fieldsOrderLength - 1]].width,
          );

          return (
            <MultiGrid
              ref={element => {
                multiGridRef.current = element;
              }}
              cellRenderer={gridProps => (
                <GridCell
                  key={gridProps.key}
                  gridProps={gridProps}
                  cellProps={{
                    multiGridSettings
                  }}
                />
              )}
              height={tableHeight}
              width={width}
              rowHeight={rowIndex =>
                rowIndex.index === 0 ? CELL_SETTINGS.headerHeight : CELL_SETTINGS.cellDataHeight
              }
              columnWidth={({ index }) =>
                index === fieldsOrderLength - 1
                  ? lastColumnWidth
                  : INVOICE_ALL_FIELDS[INVOICE_FIELDS_ORDER[index]].width
              }
              rowCount={listLength + 1}
              columnCount={fieldsOrderLength}
              fixedRowCount={multiGridSettings.fixedRowCount}
              fixedColumnCount={multiGridSettings.fixedColumnCount}
              enableFixedRowScroll
              enableFixedColumnScroll
              hideTopRightGridScrollbar
              hideBottomLeftGridScrollbar
              styleBottomRightGrid={{ willChange: 'auto' }}
              onScroll={({ scrollLeft, scrollTop }) => onScroll(scrollLeft, scrollTop)}
            />
          );
        }}
      </AutoSizer>
    </MultiGridStyles.ListWrapper>
  );
};

export default InvoiceTable;
